import { Navigate, Route, Routes } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useRoles } from '@/hooks/useAuth';
import { AuditPage } from '@/pages/AuditPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { DocsPage } from '@/pages/DocsPage';
import { DomainsPage } from '@/pages/DomainsPage';
import { JobsPage } from '@/pages/JobsPage';
import { NodesPage } from '@/pages/NodesPage';
import { BackupsPage } from '@/pages/BackupsPage';
import { ContentPage } from '@/pages/ContentPage';
import { IntegrationsPage } from '@/pages/IntegrationsPage';
import { SiteDetailPage } from '@/pages/SiteDetailPage';
import { SeoPage } from '@/pages/SeoPage';
import { ServerPage } from '@/pages/ServerPage';
import { SitesPage } from '@/pages/SitesPage';
import { TemplatesPage } from '@/pages/TemplatesPage';
import { UsersPage } from '@/pages/UsersPage';
import { can } from '@/utils/permissions';

/**
 * Which page is at which address. Screens an account cannot use have no route
 * here; the server refuses their requests regardless.
 */
export function AppRoutes(): ReactNode {
  const roles = useRoles();

  return (
    <Routes>
      <Route path="/" element={<DashboardPage />} />
      <Route path="/sites" element={<SitesPage />} />
      <Route path="/sites/:id" element={<SiteDetailPage />} />
      <Route path="/seo" element={<SeoPage />} />
      <Route path="/content" element={<ContentPage />} />
      <Route path="/servers" element={<NodesPage />} />
      <Route path="/servers/:id" element={<ServerPage />} />
      <Route path="/backups" element={<BackupsPage />} />
      {can(roles, 'domains.purchase') ? <Route path="/domains" element={<DomainsPage />} /> : null}
      <Route path="/jobs" element={<JobsPage />} />
      <Route path="/templates" element={<TemplatesPage />} />
      {can(roles, 'secrets.manage') ? <Route path="/integrations/:kind?" element={<IntegrationsPage />} /> : null}
      {can(roles, 'team.manage') ? <Route path="/team" element={<UsersPage />} /> : null}
      {can(roles, 'audit.read') ? <Route path="/audit" element={<AuditPage />} /> : null}
      <Route path="/docs" element={<DocsPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
